/**
 * @fileoverview The roles shown as columns on the Capabilities page.
 * @description The Sales tab lists the four Sales-organization roles, in this order, out of the
 * wider role catalogue GET /authorization/roles returns. Roles the catalogue doesn't hold (not yet
 * seeded, or inactive) are left out rather than shown empty.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** @description The Sales roles, left to right as the matrix's columns. */
export const SALES_ROLE_CODES = [
  'SUPER_ADMIN',
  'SALES_HEAD',
  'SALES_MANAGER',
  'SALES_EXECUTIVE',
] as const
